export default __webpack_public_path__ + "static/media/step4.eb5cfe12.png";